import type { CSSProperties } from 'react';
import type { CSSObject } from '@emotion/react';

export const claimTableSelectFilterStyles = {
  getControl: (colorScheme: string): CSSProperties => ({
    borderBottom: `2px solid ${
      colorScheme === 'dark'
        ? 'var(--mantine-color-gray-7)'
        : 'var(--mantine-color-gray-3)'
    }`,
    fontWeight: 'normal',
    minWidth: 'calc(6.25rem * var(--mantine-scale))',
    width: '100%',
  }),
  dropdown: {
    padding: '6px',
    borderRadius: '8px',
    background: 'var(--mantine-color-default)',
    boxShadow: 'var(--mantine-shadow-lg)',
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1px',
    maxHeight: 'min(520px, 65vh)',
    overflowY: 'auto',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    padding: '7px 9px',
    borderRadius: '6px',
    color: 'var(--mantine-color-text)',
    fontSize: '13px',
    fontWeight: 600,
    '&[data-combobox-active]': {
      background: 'var(--mantine-primary-color-light)',
    },
    '&:not([data-combobox-disabled]):hover, &[data-combobox-selected]': {
      background: 'var(--mantine-color-default-hover)',
      color: 'var(--mantine-color-text)',
    },
    '&[data-combobox-disabled]': {
      opacity: 0.38,
      cursor: 'not-allowed',
    },
  },
  indicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '15px',
    height: '15px',
    border: '1px solid var(--mantine-color-default-border)',
    borderRadius: '3px',
    '[data-combobox-active] &': {
      borderColor: 'var(--mantine-primary-color-filled)',
      background: 'var(--mantine-primary-color-filled)',
      color: 'var(--mantine-color-white)',
    },
  },
  clear: {
    display: 'block',
    width: '100%',
    marginTop: '4px',
    padding: '8px 9px',
    borderTop: '1px solid var(--mantine-color-default-border)',
    color: 'var(--mantine-color-dimmed)',
    fontSize: '12px',
    fontWeight: 600,
    '&:hover': {
      color: 'var(--mantine-color-text)',
    },
  },
} satisfies Record<
  string,
  CSSObject | ((colorScheme: string) => CSSProperties)
>;
